export default __webpack_public_path__ + "static/media/location-example.e80262de.png";